// extracted by mini-css-extract-plugin
export var numpadContainer = "_nh-1";
export var phoneButton = "_nh-0";